import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { UTMParamTable } from "./components/utm-param-table";
import { URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.REVCONTENT;

export const RevcontentDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const RevcontentSetup = () => (
  <>
    <SetupSection title="Input parameter pairs for each campaign in the ’UTM Tracking’ section.">
      <UTMParamTable platform={PLATFORM} />
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
